//@ts-check
import { createContext } from "react";
export const Authentication = createContext(null);
